 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		40: 0,
 		51: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~MergeApproval~MergeRequest~OneRosterOrgs~ProvisionSchools~Pygmalion","5":"News","6":"MergeApproval~MergeRequest","8":"AssignmentContainer","9":"AssignmentsContainer","10":"BulkRoster","11":"Categories","12":"Collections","13":"Home","14":"LazyAssignedArticleReviewContainer","15":"LazyCanvasAssignmentReviewContainer","16":"LazySearchComponent","17":"LessonSparkContainer","18":"MergeApproval","19":"MergeRequest","20":"OneRosterOrgs","21":"OpenMergeRequests","22":"ProvisionSchools","23":"Pygmalion","24":"ReadContainer","25":"Rules","26":"Search","27":"Search Playground","28":"SignIn","29":"StandaloneAudioTrack","30":"StandaloneExternalEmbed","31":"StandalonePoll","32":"StandaloneVideo","33":"StandardContainer","34":"TeacherBinder","35":"TeacherOnboarding","36":"TextSets","37":"UnitsContainer","38":"UserDash","39":"YourContentContainer","41":"browse","44":"vendors~BulkRoster"}[chunkId]||chunkId) + "." + {"0":"ed6dac8c9ca262fa31be","1":"29ed6fedd5fd0258b4ce","2":"b44707c63f392259973b","3":"f529483bf6d40a5e6148","4":"d9dccc8a4e4d45e435c9","5":"b3a3e7c33f1db14fd6c0","6":"bd4a88dc7b83fdb52780","7":"e62a1f68563271bbd8d7","8":"1f66e7664636aa405f4f","9":"68b50944e4e74b232e44","10":"6f6c6b31edfa6be84400","11":"73d1e3b72e36c390974f","12":"b1df6b17cc4c74641c19","13":"4bc98d88e83243d4be17","14":"b226baa9d8fd37786842","15":"9da8c4c987f8285c2742","16":"d6b9049db11031d7b988","17":"8d446974736993cc8d37","18":"3759a99f058c02046345","19":"df9bb0fa78585eb1d1f6","20":"84953b02c94dc3487009","21":"b4859b8cde239a4b9d75","22":"5fecb3c41847364e8031","23":"1f53d62d06f0c288109b","24":"5d88137d5a52d3e02551","25":"13023002980145aee2bb","26":"b51a30761efc023d3135","27":"bc86b50d4c89b99a4bb9","28":"70dac7c2e5a413adb47d","29":"e6775d5ed90dd377a8ce","30":"79b085068bbf8e919830","31":"962b65da947eaf8c5dd5","32":"8f7247fe26c15c922716","33":"77f4b0d12add9567d0c8","34":"6d447c3f73f7b21bf24d","35":"584a9d7b9bf8af658f29","36":"83f78b14cf8fd1aa7187","37":"1dfd021586fca1fab11b","38":"b7ee142b45b59089548d","39":"70fd7b4a02f4b0fe509f","41":"b231bcad715023a5363e","44":"c7bf6e1e4036df5e9e09","45":"4a73f34cf3338e6dd5f8","46":"5c80f0df5ebeed115951","47":"206fdca03119467e2ac2","48":"6e396430672a7e32b859","49":"f0262412342b6a85c77a","50":"b71c1e54dea0a8a9b912","51":"586eb59306634f2a9730","52":"8d8311b9dd841b7ca538","53":"f68fdda778bf2484ceca","54":"75d9122f17813351c327","55":"a71c60a025ad225fb4f8","56":"45bd82bb96f2937fb986","57":"94d8b7787127c0d7b9bb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1918);
